import React from 'react';

const Dashboard = ({ user }) => {
  return (
    <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
      <div className="bg-card rounded-lg shadow-md p-6">
        <h2 className="text-3xl mb-4">Statistics</h2>
        <div className="text-3xl font-bold mb-2">42</div>
        <p className="text-muted-foreground">Total items processed</p>
      </div>

      <div className="bg-card rounded-lg shadow-md p-6">
        <h2 className="text-3xl mb-4">Recent Activity</h2>
        <ul className="space-y-3">
          {[1, 2, 3].map(item => (
            <li key={item} className="pb-2 border-b">
              <div className="text-sm text-muted-foreground">{item} day{item > 1 ? 's' : ''} ago</div>
              <div>Activity item {item}</div>
            </li>
          ))}
        </ul>
      </div>

      <div className="bg-card rounded-lg shadow-md p-6">
        <h2 className="text-3xl mb-4">Quick Links</h2>
        <div className="space-y-2">
        </div>
      </div>
    </div>
  );
};

export default Dashboard; 